import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'project-create-importer-upload-flow.select-source-screen.heading',
		defaultMessage: 'Import data into Jira',
		description: 'page heading',
	},
	pageDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.page-description',
		defaultMessage:
			'Import from any app into a new business or software project. Your imports will not affect current issues and users in Jira.',
		description: 'Helper text to let users know this importer',
	},
	pageDescriptionNew: {
		id: 'project-create-importer-upload-flow.select-source-screen.page-description-new',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'You can import from any app into a new business or software project. If you’d like to import data into Jira Service Management or Jira Product Discovery, <link>switch to the old experience</link>. {br}{br}While we continue building this space, you can switch between experiences as needed. <learnNewImportExperienceLink>Read about the new import experience</learnNewImportExperienceLink>',
		description: 'Helper text to let users know this importer',
	},
	sectionHeading: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-heading',
		defaultMessage: 'You’re in the new import experience',
		description: 'Section message heading of new experience',
	},
	sectionDescription: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-description',
		defaultMessage:
			'With the <link>new experience</link>, you can import data from any app into a new Jira business or software project.',
		description: 'Section message description of new experience',
	},
	sectionDescriptionPara2: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-description-para-2',
		defaultMessage:
			'While we work on building more capabilities, we recommend that you use the old experience to:',
		description:
			'Section message description para to stating about lacking features in new importer',
	},
	sectionDescriptionCapability1: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-description-capability-1',
		defaultMessage: 'Move data into an existing project in Jira',
		description: 'Section message capability features list 1 of 3',
	},
	sectionDescriptionCapability2: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-description-capability-2',
		defaultMessage: 'Import data into Jira Service Management or Jira Product Discovery',
		description: 'Section message capability features list 2 of 3',
	},
	sectionDescriptionCapability3: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-description-capability-3',
		defaultMessage: 'Use JSON files to move data',
		description: 'Section message capability features list 2 of 3',
	},
	sectionSwitchToOldExperience: {
		id: 'project-create-importer-upload-flow.select-source-screen.section-switch-to-old-experience',
		defaultMessage: 'Switch to the old experience',
		description: 'Setion message action switch to old experience',
	},
});
